<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>{{ $t("PARTNER") }}＞ {{ $t(this.FormTitle) }}</strong>
        </h5>
        <div v-if="this.createPartner.userid">
          <h5 class="vue-title">
            <strong>{{ $t("ID") }} : {{ this.createPartner.userid }}</strong>
          </h5>
        </div>
        <b-form
          class="formTextSize"
          @submit.prevent="submitCreatePartnerForm"
          autocomplete="off"
        >
          <b-row>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CATEGORYNAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-select
                  id="parentName"
                  value-field="id"
                  text-field="name"
                  @change="selectCustomFields"
                  v-model.trim="$v.createPartner.category_id.$model"
                  :options="masterList"
                ></b-form-select>
                <show-errors
                  :control="$v.createPartner.category_id"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("CLINICID") }}</span>
                <b-form-input
                  id="name"
                  v-model.trim="$v.createPartner.client_id.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.client_id.name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  提携先名
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="name"
                  v-model.trim="$v.createPartner.name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("POSTALCODE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="postal_code"
                  @keypress="isNumberValidatorPost($event)"
                  v-model.trim="$v.createPartner.postal_code.$model"
                  class="inputField"
                  type="tel"
                  @blur="checkPostalCode"
                  @keydown="removeDash($event)"
                  autocomplete="off"
                  :maxlength="CONSTANTS.postalCode"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.postal_code"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PREFECTURES") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="prefecture"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  v-model.trim="$v.createPartner.prefecture.$model"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.prefecture"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CITY") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="city"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  v-model.trim="$v.createPartner.city.$model"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.city"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("STREETADDRESS") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="street_address"
                  v-model.trim="$v.createPartner.street_address.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.street_address"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("BUILDINGNAME") }}</span>
                <b-form-input
                  id="building_name"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  v-model.trim="$v.createPartner.building_name.$model"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.building_name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("MOBILE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="contact_no"
                  @keypress="isNumberValidatorphone($event)"
                  v-model.trim="$v.createPartner.contact_no.$model"
                  class="inputField"
                  type="tel"
                  autocomplete="off"
                  :maxlength="CONSTANTS.MaxPhone"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.contact_no"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("EMAIL") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.createPartner.email.$model"
                  class="inputField"
                  type="text"
                  @keypress="preventSpecialChar($event)"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.email"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("FAX") }}</span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.createPartner.fax.$model"
                  class="inputField"
                  type="text"
                  :maxlength="CONSTANTS.fax"
                  autocomplete="off"
                  @keypress="isNumberValidator($event)"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.fax"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>

            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PERSONINCHARGE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="person_in_charge"
                  v-model.trim="$v.createPartner.person_in_charge.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.person_in_charge"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CONTACTNAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.createPartner.contact_name.$model"
                  class="inputField"
                  type="text"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createPartner.contact_name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              v-for="(item, index) in selectedCustomList"
              :key="index"
            >
              <b-form-group
                id="addressField"
                label-for="input-1"
                v-if="item.type != 'date'"
              >
                <span>
                  {{ item.name }}
                </span>
                <b-form-input
                  class="inputField"
                  :type="item.type"
                  autocomplete="off"
                  v-model="selectedCustomList[index].text"
                ></b-form-input>
              </b-form-group>
              <b-form-group id="addressField" label-for="input-1" v-else>
                <span>
                  {{ item.name }}
                </span>

                <date-picker
                  :lang="lang"
                  class="datePickerCss custom-date-picker"
                  placeholder="YYYY-MM-DD"
                  v-model="selectedCustomList[index].text"
                  type="date"
                  :editable="true"
                  valuetype="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                ></date-picker>
              </b-form-group>
            </b-col>
          </b-row>

          <br />
          <b-row>
            <b-col sm="12" class="text-center">
              <b-button
                class="btn btn-secondary formTextSizeBlack mr-2"
                to="/partner_service_list"
                >{{ $t("CANCEL") }}</b-button
              >
              <button class="btn btn-primary formTextSizeBlack" type="submit">
                {{ $t("ADDTO") }}
              </button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  CREATE_PARTNER_SERVICE,
  GET_ALL_PARTNER_MASTER,
  GET_SERVICE_PARTNER,
  EDIT_SERVICE_PARTNER
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import * as _ from "lodash";
import { required, email, minLength, numeric } from "vuelidate/lib/validators";
import ShowErrors from "@/components/ShowErrors";
import {
  isNumberValidator,
  preventSpecialChar,
  phoneDigitValidation,
  isNumberValidatorphone
} from "@/shared/utils.js";
import { CONSTANTS, pickAs } from "@/shared/utils";
import moment from "moment";

export default {
  name: "add-partner",
  components: {
    ShowErrors,
    DatePicker
  },

  data: function() {
    return {
      FormTitle: "",
      preventSpecialChar: preventSpecialChar,
      isNumberValidator: isNumberValidator,
      isNumberValidatorphone: isNumberValidatorphone,
      params: {},
      CONSTANTS: CONSTANTS,
      pickAs: pickAs,
      createPartner: {
        category_id: "",
        parentName: "",
        person_in_charge: "",
        name: "",
        category: "",
        street_address: "",
        contact_no: "",
        email: "",
        prefecture: "",
        building_name: "",
        city: "",
        postal_code: "",
        fax: "",
        contact_name: "",
        userid: "",
        client_id: ""
      },
      form: {
        parent_id: []
      },
      selectedCustomList: [],
      partnercreateObj: {},
      masterList: []
    };
  },
  /*validation for the Each fields in From */
  validations: {
    createPartner: {
      category_id: {
        required
      },
      name: {
        required
      },
      person_in_charge: {
        required
      },
      street_address: {
        required
      },
      contact_no: {
        required,
        phoneNumber: minLength(10)
      },
      email: {
        required,
        email
      },
      prefecture: {
        required
      },
      building_name: {},
      city: {
        required
      },
      postal_code: {
        required,
        postalCode: minLength(8)
      },
      contact_name: {
        required
      },
      fax: {
        minLength: minLength(10),
        numeric
      },
      client_id: {}
    },

    partnercreateObj: {},
    additioncreatePartner: []
  },
  methods: {
    /* Remove digit when user removing dash */
    removeDash(evt) {
      if (this.createPartner.postal_code.length == 4) {
        this.createPartner.postal_code = this.createPartner.postal_code.substring(
          0,
          this.createPartner.postal_code.length - 1
        );
      }
    },
    /*Postal code validating. Adding - after */
    isNumberValidatorPost(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      if (this.createPartner.postal_code.length == 3) {
        this.createPartner.postal_code = this.createPartner.postal_code + "-";
      } else if (this.createPartner.postal_code.length < 3) {
        this.createPartner.postal_code = this.createPartner.postal_code.replace(
          "-",
          ""
        );
      }
    },
    /* On focus out do postal code format */
    checkPostalCode() {
      let temp = this.createPartner.postal_code.replace("-", "");
      if (temp.length > 3) {
        let startString = temp.slice(0, 3);
        let endString = temp.slice(3, 7);
        this.createPartner.postal_code = startString + "-" + endString;
      }
    },
    /* Onselect partner add custom fields to form */
    selectCustomFields(partnerId) {
      let findItem = _.find(
        this.partnerMasterList.list,
        item => item.id == partnerId
      );
      this.selectedCustomList = JSON.parse(findItem.fields);
    },

    /**
     * Sumbitting the Filled Form
     * Input @param {object} object  this.createPartner object which is filled by the user / in Edit also Using the same function
     * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
     */
    async submitCreatePartnerForm(evt) {
      this.$v.$touch();
      if (!this.$v.createPartner.$invalid) {
        if (phoneDigitValidation(this.createPartner.contact_no) === true) {
          this.$toast.error({
            message: this.$t("INVALIDPHONENO")
          });
          return;
        }
        let paylod = this.createPartner;
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let dateObj = _.find(
          this.selectedCustomList,
          item => item.type == "date"
        );
        if (dateObj) {
          let dateObjIndex = _.findIndex(
            this.selectedCustomList,
            item => item.type == "date"
          );
          this.selectedCustomList[dateObjIndex].text = moment(
            dateObj.text
          ).format("YYYY-MM-DD");
        }

        paylod["additional_fields"] = JSON.stringify(this.selectedCustomList);
        /* Triggering edit api if it is Edit with from data as payload */
        if (_.get(this.params, "id", 0)) {
          paylod["id"] = this.params.id;
          let data = await this.$store.dispatch(EDIT_SERVICE_PARTNER, paylod);
          this.isLoading.hide();
          if (_.get(data, "status", false)) {
            this.$toast.success({
              message: _.get(data, "message", "")
            });
            this.$router.push({
              name: "partnersList"
            });
          } else {
            this.$toast.error({
              message: _.get(data, "message", "")
            });
          }
        } else {
          /*else part we are just calling the create api */
          let data = await this.$store.dispatch(CREATE_PARTNER_SERVICE, paylod);
          this.isLoading.hide();
          if (_.get(data, "status", false)) {
            this.$toast.success({
              message: _.get(data, "message", "")
            });
            this.$router.push({
              name: "partnersList"
            });
          } else {
            this.$toast.error({
              message: _.get(data, "message", "")
            });
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(["partnerMasterList"])
  },
  async created() {
    this.params = this.$route.params;
    this.FormTitle = "CREATE";
    this.$store.dispatch(GET_ALL_PARTNER_MASTER).then(data => {
      let list = [];
      $.each(data.categories, function(key, value) {
        if (value.status === "active") {
          list.push(value);
        }
      });
      this.masterList = list;
    });

    this.params = this.$route.params;

    if (_.get(this.params, "id", 0)) {
      /*prefilling the form if it EditPage*/
      this.FormTitle = "EDIT";
      this.isLoading = this.$loading.show({
        loader: "dots",
        color: "#007bff"
      });

      let data = await this.$store.dispatch(GET_SERVICE_PARTNER, {
        id: _.get(this.params, "id", 0)
      });
      this.isLoading.hide();

      if (_.get(data, "status", 0)) {
        let partnerObj = _.get(data, "partner");
        let fileds = _.get(partnerObj, "fields", "[]");
        this.list2 = JSON.parse(fileds);
        this.createPartner = this.pickAs(partnerObj, {
          //Prefilling the Edit Form from responce
          category_id: "category_id",
          name: "name",
          email: "email",
          contact_no: "contact_no",
          building_name: "address.building_name",
          postal_code: "address.postal_code",
          city: "address.city",
          street_address: "address.street_address",
          prefecture: "address.prefecture",
          fax: "fax",
          person_in_charge: "person_in_charge",
          clinic_name: "clinic_name",
          contact_name: "contact_name",
          userid: "user.userid",
          client_id: "client_id"
        });

        this.selectedCustomList = JSON.parse(
          _.get(partnerObj, "additional_fields", "[]")
        );
        let dateObj = _.find(
          this.selectedCustomList,
          item => item.type == "date"
        );
        if (dateObj) {
          let dateObjIndex = _.findIndex(
            this.selectedCustomList,
            item => item.type == "date"
          );
          this.selectedCustomList[dateObjIndex].text = new Date(dateObj.text);
        }
      }
    }

    let selectedObj = this.$route.params.selectedRow;
  }
};
</script>

<style scoped>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}

.list-group-item {
  margin-bottom: 6px;
}
</style>
